// src/components/SelectedForms.js
import React, { useState, useEffect, useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { hasDraftForFormId, draftLabelForFormId } from '../lib/applicationDrafts';
import './ApplicationForms.css';
import JoinedForm from '../forms/JoinedForm'; 
import PaidLeaveForm from '../forms/PaidLeaveForm'; 
import SeiriLeaveForm from '../forms/SeiriLeaveForm';
import RemoveForm from '../forms/RemoveForm';
import NameChangeForm from '../forms/NameChangeForm';
import AddressChangeForm from '../forms/AddressChangeForm';
import TrainsChangeForm from '../forms/TrainsChangeForm';
import FamilyChangeForm from '../forms/FamilyChangeForm';
import BankChangeForm from '../forms/BankChangeForm';
import RetirementForm from '../forms/RetirementForm';
import MyNumberForm from '../forms/MynumberForm';
import SpecialLeaveForm from '../forms/SpecialLeaveForm';
import TimeOverForm from '../forms/TimeOverForm';
import TransportApply from '../forms/TransportApply';
import AllowanceForm from '../forms/allowanceForm';
import HolidayWorkForm from '../forms/HolidayWorkForm'; 


const formComponents = {
    joined: JoinedForm,
    paid_leave: PaidLeaveForm,
    seiri_leave: SeiriLeaveForm,
    remove: RemoveForm,
    name_change: NameChangeForm,
    address_change: AddressChangeForm,
    trains_change: TrainsChangeForm,
    family_change: FamilyChangeForm,
    bank_change: BankChangeForm,
    retirement: RetirementForm,
    mynumber: MyNumberForm,
    specialLeave: SpecialLeaveForm,
    timeOver: TimeOverForm,
    transport_apply: TransportApply,
    allowance: AllowanceForm,
    holiday_work: HolidayWorkForm,
};

const SelectedForms = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    //const formIds = searchParams.get('ids')?.split(',') || [];
    const formIds = useMemo(() => (searchParams.get('ids') || '').split(',').filter(Boolean), [searchParams]);

    const draftId = searchParams.get("id");
    const isDraft = Boolean(draftId);

    const [currentFormIndex, setCurrentFormIndex] = useState(0);
    const [draftTick, setDraftTick] = useState(0);

    useEffect(() => {
        const fn = () => setDraftTick((t) => t + 1);
        window.addEventListener('application-draft-saved', fn);
        return () => window.removeEventListener('application-draft-saved', fn);
    }, []);

    const currentFormId = formIds[currentFormIndex];
    const showDraftBanner = useMemo(
        () => (currentFormId ? hasDraftForFormId(currentFormId) : false),
        [currentFormId, draftTick]
    );

    const FormToDisplay = formComponents[formIds[currentFormIndex]];

    const handleNext = () => {
        if (currentFormIndex < formIds.length - 1) {
            setCurrentFormIndex(prevIndex => prevIndex + 1);
        } else {
            
            alert('全て申請フォームを入力完了しました.');
            navigate('/applications');
        }
    };
    
    const handleBack = () => {
        if (currentFormIndex > 0) {
            setCurrentFormIndex(prevIndex => prevIndex - 1);
        } else {
            navigate('/applications');
        }
    };

    if (formIds.length === 0) {
        return <div>選択しましたフォームがありません。.</div>;
    }

    return (
        <div className="container mt-5 selected-forms-container">
            <div className="card p-4">
                {showDraftBanner && currentFormId && (
                    <div className="form-draft-top-banner" role="status">
                        「{draftLabelForFormId(currentFormId)}」の一時保存があります。続きから編集できます。
                    </div>
                )}
                {FormToDisplay ? (
                    <FormToDisplay
                        isMultiForm={formIds.length > 1}
                        onBack={handleBack}
                        onNext={handleNext}
                        isFirstForm={currentFormIndex === 0}
                        isLastForm={currentFormIndex === formIds.length - 1}
                    
                        id={draftId}
                        isDraft={isDraft}
                    />
                ) : (
                    <div>内容が見つかりません.</div>
                )}
            </div>
        </div>
    );
};

export default SelectedForms;